import { render, staticRenderFns } from "./WarrantyClaimLineProductDetails.vue?vue&type=template&id=53168da5&scoped=true&"
import script from "./WarrantyClaimLineProductDetails.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimLineProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyClaimLineProductDetails.vue?vue&type=style&index=0&id=53168da5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53168da5",
  null
  
)

export default component.exports